import i18n from 'i18next';
import { initReactI18next } from '../../node_modules/react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector/cjs';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;